/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseOfGetUserRolesResponse } from '../models/ApiResponseOfGetUserRolesResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class UserRoleService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns ApiResponseOfGetUserRolesResponse 
     * @throws ApiError
     */
    public getUserRoles(): CancelablePromise<ApiResponseOfGetUserRolesResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/user-role/',
        });
    }

}
